<template>
  <div id="fees" class="container-fluid">
    <div class="row fidelior-dark-background p-3">
      <div class="col-md-2 d-none d-sm-block"></div>
      <div class="col-md-8 pb-4 pt-4 container-fluid">
        <div class="row">
          <div class="col-md-6">
            <h2>Licensing</h2>
            <p>An annual subscription to Fidelior gives you full access to the platform.</p>
            <p>Report bundles are purchased additionally.</p>
            <p>Your reports do not expire as long as you have an active subscription.</p>
          </div>
          <div class="col-md-6">
            <b-card-group deck class="text-center">
              <b-card header="Launch Special" header-tag="header" no-body class="card-fees mb-2">
                <b-card-body class="d-flex flex-column">
                  <h3>€4.99</h3>
                  <span class="text-muted">/ mo</span>
                  <b-card-text class="fidelior-text-small">
                    <p>First 10 reports free</p>
                    <p>
                      <em>This offer is valid to the first 100,000 subscribers for one year only</em>
                    </p>
                  </b-card-text>
                  <a
                    href="https://app.fidelior.net/login"
                    class="btn btn-primary w-100 text-uppercase mt-auto"
                    role="button"
                  >Subscribe</a>
                </b-card-body>
              </b-card>
              <b-card header="Launch Special" header-tag="header" no-body class="card-fees mb-2">
                <b-card-body class="d-flex flex-column">
                  <h3 class="mb-0">€4.99+</h3>
                  <span class="text-muted">/ once-off</span>
                  <b-card-text class="fidelior-text-small">
                    <table class="table mt-3">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col">Reports</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">€4.99</th>
                          <td>5</td>
                        </tr>
                        <tr>
                          <th scope="row">€9.99</th>
                          <td>12</td>
                        </tr>
                        <tr>
                          <th scope="row">€14.99</th>
                          <td>20</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card-text>
                  <a
                    href="https://app.fidelior.net/login"
                    class="btn btn-primary w-100 text-uppercase mt-auto"
                    role="button"
                  >Purchase</a>
                </b-card-body>
              </b-card>
              <b-card header="Institution" header-tag="header" no-body class="card-fees mb-2">
                <b-card-body class="d-flex flex-column">
                  <b-card-text class="fidelior-text-small">
                    <p>Need a custom made package to suit your institutional needs?</p>
                    <p>Allow us to provide you with a tailored licensing fee.</p>
                  </b-card-text>
                  <a
                    href="http://fidelior.net/contact-us/"
                    class="btn btn-primary w-100 text-uppercase mt-auto"
                    role="button"
                  >Get a quote</a>
                </b-card-body>
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
      <div class="col-md-2 d-none d-sm-block"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>